// A doc is a PDF unless it carries an explicit non-PDF extension: many scraped docs
// have extensionless names but are PDFs. Kept free of pdfjs so the main chunk can use it.
const NON_PDF = /\.(docx?|xlsx?|csv|pptx?|png|jpe?g|txt|zip|eml|msg)$/i;

export function isPdf(name) {
  const n = String(name || "").split("?")[0];
  if (!n) return false;
  return !NON_PDF.test(n);
}

// Several names for one doc (display name, blob path): PDF unless any has a non-PDF extension.
export function isPdfDoc(...names) {
  const given = names.filter(Boolean);
  return given.length > 0 && given.every(isPdf);
}
